import {O, RunInAction} from "web-vcore";
import * as THREE from "three";
import {ignore} from "mobx-sync";

export enum TestingTab {
	general = "general",
	session = "session",
	eyeMove = "eyeMove",
	bridges = "bridges",
	mobX = "mobX",
}

export class TestingState {
	@O accessor expanded = false;
	@O accessor tab = TestingTab.general;

	// general tab
	// ==========

	@O accessor errorMessage = "Custom error message from testing-panel.";

	// temporarily put here
	@O accessor vrLightmap = new VRLightmapState();

	// session tab
	// ==========

	@O @ignore accessor overrideBreathData = false;
	@O accessor overrideBreathData_breathInterval = 2.5; // in seconds
	@O @ignore accessor allowEarlyBreathIntervalEffects = false;

	// eye-move detection tab
	// ==========

	@O accessor selectedUser: string;
	@O accessor xRange = 30;
	@O accessor yRange = 15;
	//@O normalize = true;
	//@O smooth = true;
	@O accessor falseDetectionPenalty = .25;
	@O accessor showDetections = true;

	@O @ignore accessor runTests = false;
	//@O testResults = [] as TestResult[];
	@O @ignore accessor averageTestScore: number;

	// bridges tab
	// ==========

	@O accessor lastBridgeMessages_changedAt = 0;
}

export const ImageEncodeFormat_values = ["png", "jpeg", "webp"] as const;
export type ImageEncodeFormat = typeof ImageEncodeFormat_values[number];

export class VRLightmapState {
	// general
	@O accessor debugLightmap = false;

	// load from server
	@O accessor autoLoadLightmapFromServer = true;
	@O accessor modelLoadWaitTime = 1000; // in ms; how long with all known models loaded, to deem all models as truly being loaded (since some models in react render-tree may be briefly delayed in registering)

	// bake
	@O accessor resolution = 4096;
	@O accessor renderSteps = 500;
	@O accessor maxRenderStepsPerFrame = 5000;

	// upload
	@O accessor format = "png" as ImageEncodeFormat;
	@O accessor quality = 1; // 0-1 (only jpeg and webp formats meaningfully-support <1)

	@O @ignore accessor lastBake_status = "initial" as "initial" | "waitForModelsLoaded" | "prepping" | "rngReset" | "baking" | "done";
	// if baking ourselves
	@O @ignore accessor lastBake_renderStepsLeft = 0;
	//@O @ignore lastBake_imageOverride: Blob|n = null;
	@O @ignore accessor lastBake_imageOverride: THREE.Texture|n = null;

	StartBake_Fresh(renderSteps: number) {
		RunInAction("StartBake_Fresh", ()=>{
			this.lastBake_status = "waitForModelsLoaded";
			this.lastBake_renderStepsLeft = renderSteps;
			// clear other (potentially old) fields
			this.lastBake_imageOverride = null;
		});
	}
	StartBake_FromImage(imageAsTexture: THREE.Texture) {
		RunInAction("StartBake_FromImage", ()=>{
			this.lastBake_status = "waitForModelsLoaded";
			this.lastBake_imageOverride = imageAsTexture; // set the image override
			// clear other (potentially old) fields
			this.lastBake_renderStepsLeft = 0;
		});
	}
}